import type { Item, ItemType } from '@trips/shared/schema';
import type { IconName } from './Icon';

/** One icon per kind of plan, used in the picker, the timeline and search. */
export const ITEM_ICON: Record<ItemType, IconName> = {
  flight: 'airplane-tilt',
  lodging: 'bed',
  car: 'car',
  restaurant: 'fork-knife',
  activity: 'ticket',
  train: 'train-simple',
  bus: 'bus',
  ferry: 'boat',
  cruise: 'anchor',
  transfer: 'taxi',
  parking: 'letter-circle-p',
  other: 'map-pin',
};

/** A home for Airbnbs and rentals, a bed for hotels. */
export function itemIcon(
  item: Pick<Item, 'type' | 'details'> | undefined,
  type: ItemType,
): IconName {
  if (
    item?.details.type === 'lodging' &&
    (item.details.kind === 'airbnb' || item.details.kind === 'rental')
  )
    return 'house-line';
  return ITEM_ICON[type];
}
